import { faCashRegister } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useSearchParamsUpdater } from 'hooks/useSearchParamsUpdater';
import { useSyncedDate } from 'hooks/useSyncedDate';
import { formatDate } from 'helpers/formatDate';
import { scrollDate } from 'helpers/scrollDate';
import { DatePicker } from 'components/DatePicker';
import { Button } from 'components/Button';
import { ChooseLocation } from 'common/ChooseLocation';
import styles from 'pages/CashRegister/Header/Header.scss';

export const Header = ({ showSafeForm, setShowSafeForm }) => {
  const query = useSearchParamsUpdater();
  const { locationName } = useParams();
  const todayDate = formatDate(new Date());

  const locationTransliteration = query.getParam('location') || locationName;

  const [currentDate, setCurrentDate] = useSyncedDate(!!locationTransliteration);
  const handleDateChange = useCallback(
    (direction) => setCurrentDate((prev) => scrollDate(prev, direction)),
    [setCurrentDate]
  );

  return (
    <div className={styles.header}>
      <div className={styles.titleWrapper}>
        <h1>
          <FontAwesomeIcon icon={faCashRegister} />
          Каса
        </h1>
        <p>Огляд всіх фінансових операцій</p>
      </div>
      <DatePicker
        className={styles.datePicker}
        date={currentDate}
        maxDate={todayDate}
        handleScrollDate={handleDateChange}
        showDay
        enableCalendar
      />

      <div className={styles.buttons}>
        <ChooseLocation />
        <Button text={showSafeForm ? 'Закрити' : 'Керування сейфом'} onClick={() => setShowSafeForm((prev) => !prev)} smallStyle />
      </div>
    </div>
  );
};
